import {
    ADD_DAYOFF_LOCAL, DAYOFF_MESSAGE, ADD_SURVEY_LOCAL, SURVEY_MESSAGE
} from '../actions/dayoff.js';


const initialState = {
    dayoff: {},
    survey: {},
    dayoffMessage: {},
    surveyMessage: {}
};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ADD_DAYOFF_LOCAL: {
            return {
                ...state,
                dayoff: action.payload.data,
            };
        }
        case ADD_SURVEY_LOCAL: {
            return {
                ...state,
                survey: action.payload.data,
            };
        }
        case DAYOFF_MESSAGE: {
            return {
                ...state,
                dayoffMessage: action.payload.data,
            };
        }
        case SURVEY_MESSAGE: {
            return {
                ...state,
               surveyMessage: action.payload.data,
            };
        }



        default: {
            return {
                ...state,
            };
        }
    }
}
